const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: 'block', background: 'blue', borderRadius: '100%' }} 
        onClick={onClick}
      />
    );
  };

export default PrevArrow;